import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Gallery } from "@/components/Gallery";
import { Zone } from "@/components/Zone";
import { Pricing } from "@/components/Pricing";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyCallButton } from "@/components/StickyCallButton";
import { Legal } from "@/components/Legal";

const Home = () => (
  <main className="bg-[#0A0A0A] text-white" data-testid="home-page">
    <Header />
    <Hero />
    <Services />
    <WhyUs />
    <Gallery />
    <Zone />
    <Pricing />
    <Testimonials />
    <Contact />
    <Footer />
    <StickyCallButton />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<Legal />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#171717",
            color: "#FFFFFF",
            border: "1px solid #333333",
          },
        }}
      />
    </div>
  );
}

export default App;
